import { AemFeature } from '@app/components/AdobeExperienceFragments';

import { ADDON_PRODUCT_KIND } from '../../../constants';

export function mapAddonKindToAemUrlFragment(kind: string) {
  if (kind === ADDON_PRODUCT_KIND.voice) {
    return AemFeature.ADD_ON_VOICE;
  }

  if (kind === ADDON_PRODUCT_KIND.shield) {
    return AemFeature.ADD_ON_SHIELD;
  }

  if (kind === ADDON_PRODUCT_KIND.easyCare) {
    return AemFeature.ADD_ON_EASYCARE;
  }

  if (kind === ADDON_PRODUCT_KIND.cyberProtect) {
    return AemFeature.CYBERPROTECT;
  }

  return AemFeature.ADD_ON_STATIC_IP;
}
